export var DIALOG_TYPES = /*#__PURE__*/ function(DIALOG_TYPES) {
    DIALOG_TYPES["confirm"] = "confirm";
    DIALOG_TYPES["form"] = "form";
    return DIALOG_TYPES;
}({});
export var BUTTON_TYPES = /*#__PURE__*/ function(BUTTON_TYPES) {
    BUTTON_TYPES["alert"] = "alert";
    BUTTON_TYPES["primary"] = "primary";
    BUTTON_TYPES["success"] = "success";
    return BUTTON_TYPES;
}({});

//# sourceMappingURL=dialogs.js.map